/* eslint-disable react/jsx-props-no-spreading */
import { ReactElement } from 'react';
import Button from './Button';

interface Props {
  icon: string;
  label: string;
  dataTarget?: string;
  onClick?: () => void;
}

const SplitButtonWithIcon = ({
  onClick, icon, label, dataTarget, ...rest
}: Props): ReactElement => (
  <Button
    type="button"
    className="btn btn-primary btn-icon-split"
    onClick={onClick}
    data-toggle={dataTarget ? 'modal' : undefined}
    data-target={dataTarget ? `#${dataTarget}` : undefined}
    {...rest}
  >
    <span className="icon text-white-50">
      <i className={`fas fa-${icon}`} />
    </span>
    <span className="text">{label}</span>
  </Button>
);

SplitButtonWithIcon.defaultProps = {
  dataTarget: undefined,
  onClick: undefined,
};

export default SplitButtonWithIcon;
